import repository from "../Repository";

export default {
  list() {
    return repository.post(`screen_authority`);
  }
};
